/**
 * Created by efowler on 5/7/15.
 */
namespace app.services.project {
  export class ProjectStatusService implements IService {
    private $resource: angular.resource.IResourceService;

    private httpService: app.services.IHttpWrapperService;
    private configService: app.services.IConfigService;
    private notificationService: app.services.INotificationService;
    private resourceWrapperService: app.services.utilities.ResourceWrapperService;

    private baseUrl: string;

    constructor($resource: angular.resource.IResourceService, httpService: app.services.IHttpWrapperService, configService: app.services.IConfigService, notificationService: app.services.INotificationService, resourceWrapperService: app.services.utilities.ResourceWrapperService) {
      this.$resource = $resource;
      this.httpService = httpService;
      this.configService = configService;
      this.notificationService = notificationService;
      this.resourceWrapperService = resourceWrapperService;
      this.baseUrl = this.configService.getServerBaseUrlForResource();
    }

    public FindAll(project) {
      return this.resourceWrapperService.WrapActions(this.$resource(`${this.baseUrl}/project/:id/status`, {}, {
        query: {
          method: "GET",
          isArray: true
        }
      })).query({
        id: project.id
      }).$promise;
    }
  }

  frontendApp.factory("ProjectStatusService", ['$resource', 'HttpService', 'ConfigService', 'NotificationService', 'ResourceWrapperService', function(resource, httpService, configService, notificationService, resourceWrapperService) {
    return new ProjectStatusService(resource, httpService, configService, notificationService, resourceWrapperService);
  }]);
}
